import type { GMColorsByModel } from '../types';

// GM Official Color Library by Model (2025 Model Year)
const GM_COLORS: GMColorsByModel = {
  'Silverado 1500': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Red Hot', code: 'G7C', hex: '#c41e3a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Cypress Gray', code: 'GBD', hex: '#4a5548', premium: false },
    { name: 'Riptide Blue Metallic', code: 'GJV', hex: '#1e5aa8', premium: false },
    { name: 'Radiant Red Tintcoat', code: 'GSK', hex: '#8b0000', premium: true, price: 495 },
    { name: 'Iridescent Pearl Tricoat', code: 'G1W', hex: '#e8e4d9', premium: true, price: 995 },
  ],
  'Silverado 2500HD': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Red Hot', code: 'G7C', hex: '#c41e3a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Cypress Gray', code: 'GBD', hex: '#4a5548', premium: false },
  ],
  'Silverado 3500HD': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Red Hot', code: 'G7C', hex: '#c41e3a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
  ],
  'Colorado': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Nitro Yellow Metallic', code: 'G9K', hex: '#e6c200', premium: false },
    { name: 'Radiant Red Tintcoat', code: 'GSK', hex: '#8b0000', premium: true, price: 495 },
  ],
  'Equinox': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Mosaic Black Metallic', code: 'GB8', hex: '#1a1a1e', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Cacti Green', code: 'GSW', hex: '#5a6b4a', premium: false },
    { name: 'Lakeshore Blue Metallic', code: 'GXP', hex: '#2d4a6b', premium: false },
    { name: 'Reef Blue Metallic', code: 'GMU', hex: '#1a3a5c', premium: false },
    { name: 'Radiant Red Tintcoat', code: 'GSK', hex: '#8b0000', premium: true, price: 495 },
    { name: 'Iridescent Pearl Tricoat', code: 'G1W', hex: '#e8e4d9', premium: true, price: 995 },
  ],
  'Trax': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Mosaic Black Metallic', code: 'GB8', hex: '#1a1a1e', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Cacti Green', code: 'GSW', hex: '#5a6b4a', premium: false },
    { name: 'Crimson Metallic', code: 'GSS', hex: '#8b2942', premium: false },
  ],
  'Trailblazer': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Mosaic Black Metallic', code: 'GB8', hex: '#1a1a1e', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Nitro Yellow Metallic', code: 'G9K', hex: '#e6c200', premium: false },
    { name: 'Oasis Blue', code: 'GMD', hex: '#5ba4c9', premium: false },
    { name: 'Apex Red', code: 'G1E', hex: '#a4282d', premium: false },
  ],
  'Blazer': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Radiant Red Tintcoat', code: 'GSK', hex: '#8b0000', premium: true, price: 495 },
    { name: 'Iridescent Pearl Tricoat', code: 'G1W', hex: '#e8e4d9', premium: true, price: 995 },
  ],
  'Traverse': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Mosaic Black Metallic', code: 'GB8', hex: '#1a1a1e', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Lakeshore Blue Metallic', code: 'GXP', hex: '#2d4a6b', premium: false },
    { name: 'Radiant Red Tintcoat', code: 'GSK', hex: '#8b0000', premium: true, price: 495 },
  ],
  'Tahoe': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Empire Beige Metallic', code: 'GNK', hex: '#a89880', premium: false },
    { name: 'Iridescent Pearl Tricoat', code: 'G1W', hex: '#e8e4d9', premium: true, price: 995 },
  ],
  'Suburban': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Empire Beige Metallic', code: 'GNK', hex: '#a89880', premium: false },
    { name: 'Iridescent Pearl Tricoat', code: 'G1W', hex: '#e8e4d9', premium: true, price: 995 },
  ],
  'Corvette': [
    { name: 'Arctic White', code: 'G8G', hex: '#f8f8f8', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Torch Red', code: 'GKZ', hex: '#cc0000', premium: false },
    { name: 'Rapid Blue', code: 'GMO', hex: '#0066cc', premium: false },
    { name: 'Amplify Orange Tintcoat', code: 'G48', hex: '#ff6600', premium: true, price: 995 },
    { name: 'Riptide Blue Metallic', code: 'GJV', hex: '#1e5aa8', premium: false },
  ],
  'Camaro': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Red Hot', code: 'G7C', hex: '#c41e3a', premium: false },
    { name: 'Crush', code: 'G16', hex: '#ff4500', premium: false },
    { name: 'Riverside Blue Metallic', code: 'GKK', hex: '#1a4a7a', premium: false },
  ],
  'Malibu': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Mosaic Black Metallic', code: 'GB8', hex: '#1a1a1e', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
    { name: 'Radiant Red Tintcoat', code: 'GSK', hex: '#8b0000', premium: true, price: 495 },
  ],
  'Bolt EV': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Bright Blue Metallic', code: 'G1M', hex: '#0055aa', premium: false },
    { name: 'Gray Ghost Metallic', code: 'GRX', hex: '#8a8a8a', premium: false },
  ],
  'Bolt EUV': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Bright Blue Metallic', code: 'G1M', hex: '#0055aa', premium: false },
    { name: 'Ice Blue Metallic', code: 'GLS', hex: '#a8c8d8', premium: false },
  ],
  'Silverado EV': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Sterling Gray Metallic', code: 'GXD', hex: '#6b6b6b', premium: false },
  ],
  'Equinox EV': [
    { name: 'Summit White', code: 'GAZ', hex: '#f5f5f5', premium: false },
    { name: 'Black', code: 'GBA', hex: '#1a1a1a', premium: false },
    { name: 'Riptide Blue Metallic', code: 'GJV', hex: '#1e5aa8', premium: false },
  ],
};

export default GM_COLORS;
